import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export type DeleteProductClaimPayload = {
  klaim_produk_id: string;
};
export type DeleteProductClaimResponse = ApiResponse<null>;

export const deleteProductClaim = async (
  payload: DeleteProductClaimPayload
): Promise<DeleteProductClaimResponse> => {
  const { klaim_produk_id } = payload;
  const url = `product-promotion/${klaim_produk_id}`;

  return await apiClient.delete(url);
};

export function deleteProductClaimMutationOptions() {
  return mutationOptions<
    DeleteProductClaimResponse,
    AxiosError,
    DeleteProductClaimPayload
  >({
    mutationFn: deleteProductClaim,
  });
}
